import React from "react";
import "./Footer.scss";
import { NavLink } from "react-router-dom";
import { Grid } from 'semantic-ui-react'
import linkedin from "../../assets/icons/linkedin.svg";
import fb from "../../assets/icons/facebook.svg";
import insta from "../../assets/icons/insta.svg";
import twitter from "../../assets/icons/twitter.svg";
import logo from "../../assets/icons/logo.png";
import { useTranslation } from "react-i18next";
import facebookimg from "../../assets/home/facebook5.svg";
import paytm1 from "../../assets/home/paytm1.svg";
import atosoriginlogo from "../../assets/home/atos-originlogo.svg";
import visa from "../../assets/home/visa.svg";

export default function Footer() {
    const { t, i18n } = useTranslation();
    return (
        <div className="footer_sec clearall">
            <Grid>
                <Grid.Row>
                    <Grid.Column mobile={16} tablet={7} computer={7}>
                        <div className="heading">
                            <NavLink
                                to=""> <img className="head_img" src={logo} alt="Logo" /></NavLink>
                            <p >{t('footer.para')}{" "}</p>
                                 
                        </div>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={9} computer={9}>
                        <Grid>
                            <Grid.Row>
                                <Grid.Column mobile={16} tablet={8} computer={5} className="footerMenu">
                                    <h3>{t('footer.menu1')}</h3>
                                    <ul>
                                        <li><NavLink activeClassName="active" className="nav-link" aria-current="page" to="/contest">{t('footer.Play')}</NavLink></li>
                                        <li><NavLink activeClassName="active" className="nav-link" aria-current="page" to="/aboutus">{t('footer.aboutus')}</NavLink></li>
                                        <li><NavLink activeClassName="active" className="nav-link" aria-current="page" to="/referearn">{t('footer.refer')}</NavLink></li>
                                    </ul>
                                </Grid.Column>
                                <Grid.Column mobile={16} tablet={8} computer={5} className="footerMenu">
                                    <h3>{t('footer.menu2')}</h3>
                                    <ul>
                                        <li><NavLink activeClassName="active" className="nav-link" aria-current="page" to="/termsconditions">
                                            {t('footer.terms')}
                                            
                                            </NavLink></li>
                                        <li><NavLink activeClassName="active" className="nav-link" aria-current="page" to="/privacypolicy">{t('footer.privacy')}</NavLink></li>
                                    </ul>
                                </Grid.Column>
                                <Grid.Column mobile={16} tablet={8} computer={5} className="footerMenu">
                                    <h3>{t('footer.menu3')}</h3>
                                    <ul>
                                        <li><NavLink activeClassName="active" className="nav-link" aria-current="page" to="/celebrity2">{t('footer.celebrity')}</NavLink></li>
                                        <li><NavLink activeClassName="active" className="nav-link" aria-current="page" to="/faq">{t('footer.faq')}</NavLink></li>
                                        <li><NavLink activeClassName="active" className="nav-link" aria-current="page" to="/contactus">{t('footer.contact')}</NavLink></li>
                                    </ul>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <div className="sponser">
            <p>Our  Proud sponsors</p>
            <ul>
                <li className="facebook"><a href="#"> <img src={facebookimg} /></a></li>
                <li><a href="#"><img src={paytm1} /></a></li>
                <li><a href="#"><img src={atosoriginlogo} /></a></li>
                <li><a href="#"><img src={visa} /></a></li>
            </ul>
            </div>
            <div className="copyright">
                <Grid >
                    <Grid.Row  >
                        <Grid.Column mobile={16} tablet={8} computer={8}>
                            <h6>{t('footer.para1')}</h6>
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={8} computer={8} className="copyrightImg">
                            <ul>
                                <li><a target="_blank" href="https://twitter.com/"><img src={twitter} /></a></li>
                                <li> <a target="_blank" href="https://facebook.com/"><img src={fb} /></a></li>
                                <li><a target="_blank" href="https://instagram.com/"><img src={insta} /></a></li>
                                <li> <a target="_blank" href="https://linkedin.com/"><img src={linkedin} /></a></li>
                            </ul>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        </div>
    );
};